import Accordion from '@/scripts/optional/accordion'

document.addEventListener('DOMContentLoaded', () => {
	new Accordion({
		el: '.faq-dropdown',
		trigger: '.accordion-el__head',
		showOne: true
	})
})
